import { render } from "./ManufactureSampleList.vue?vue&type=template&id=220bef4b"
import script from "./ManufactureSampleList.vue?vue&type=script&lang=js"
export * from "./ManufactureSampleList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__